module.exports = __webpack_public_path__ + "static/img/2s-info-b7.007e81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-info-b7.jpg
// module id = Jhnl
// module chunks = 0